
// @ts-nocheck


export const localeCodes =  [
  "it",
  "en",
  "fr",
  "es",
  "ro"
]

export const localeLoaders = {
  it: [
    {
      key: "locale_it_46json_2ef8f66b",
      load: () => import("#nuxt-i18n/2ef8f66b" /* webpackChunkName: "locale_it_46json_2ef8f66b" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_9a7966f9",
      load: () => import("#nuxt-i18n/9a7966f9" /* webpackChunkName: "locale_en_46json_9a7966f9" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_2d026d05",
      load: () => import("#nuxt-i18n/2d026d05" /* webpackChunkName: "locale_fr_46json_2d026d05" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_32334617",
      load: () => import("#nuxt-i18n/32334617" /* webpackChunkName: "locale_es_46json_32334617" */),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_49b3c4e9",
      load: () => import("#nuxt-i18n/49b3c4e9" /* webpackChunkName: "locale_ro_46json_49b3c4e9" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "it",
      language: "it-IT",
      name: "Italiano",
      files: [
        "/src/i18n/locales/it.json"
      ]
    },
    {
      code: "en",
      language: "en-US",
      name: "English",
      files: [
        "/src/i18n/locales/en.json"
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      name: "Français",
      files: [
        "/src/i18n/locales/fr.json"
      ]
    },
    {
      code: "es",
      language: "es-ES",
      name: "Español",
      files: [
        "/src/i18n/locales/es.json"
      ]
    },
    {
      code: "ro",
      language: "ro-RO",
      name: "Română",
      files: [
        "/src/i18n/locales/ro.json"
      ]
    }
  ],
  defaultLocale: "fr",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "fr",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "anagrafica/clienti/index": {
      it: "/anagrafica/clienti",
      en: "/registry/clients",
      fr: "/registre/clients",
      es: "/registro/clientes",
      ro: "/registru/clienti"
    },
    "anagrafica/clienti/[id]": {
      it: "/anagrafica/clienti/[id]",
      en: "/registry/clients/[id]",
      fr: "/registre/clients/[id]",
      es: "/registro/clientes/[id]",
      ro: "/registru/clienti/[id]"
    },
    "anagrafica/concessionari/index": {
      it: "/anagrafica/concessionari",
      en: "/registry/dealers",
      fr: "/registre/concessionnaires",
      es: "/registro/concesionarios",
      ro: "/registru/dealeri"
    },
    "anagrafica/concessionari/[id]": {
      it: "/anagrafica/concessionari/[id]",
      en: "/registry/dealers/[id]",
      fr: "/registre/concessionnaires/[id]",
      es: "/registro/concesionarios/[id]",
      ro: "/registru/dealeri/[id]"
    },
    "anagrafica/capi_area/index": {
      it: "/anagrafica/capi_area",
      en: "/registry/area-managers",
      fr: "/registre/chefs-de-zone",
      es: "/registro/jefes-de-zona",
      ro: "/registru/sefi-zona"
    },
    "commerciale/listini/index": {
      it: "/commerciale/listini",
      en: "/registry/pricelists",
      fr: "/registre/tarifs",
      es: "/registro/listas-de-precios",
      ro: "/registru/liste-preturi"
    },
    "commerciale/tipi_locazione/index": {
      it: "/commerciale/tipi_locazione",
      en: "/registry/rental-types",
      fr: "/registre/types-location",
      es: "/registro/tipos-de-alquiler",
      ro: "/registru/tipuri-inchiriere"
    },
    "anagrafica/gestione_file/index": {
      it: "/anagrafica/gestione_file",
      en: "/registry/file-management",
      fr: "/registre/gestion-fichiers",
      es: "/registro/gestion-archivos",
      ro: "/registru/gestionare-fisiere"
    },
    "prestazioni/offerte/index": {
      it: "/prestazioni/offerte",
      en: "/services/offers",
      fr: "/prestations/offres",
      es: "/servicios/ofertas",
      ro: "/servicii/oferte"
    },
    "prestazioni/offerte/[id]": {
      it: "/prestazioni/offerte/[id]",
      en: "/services/offers/[id]",
      fr: "/prestations/offres/[id]",
      es: "/servicios/ofertas/[id]",
      ro: "/servicii/oferte/[id]"
    },
    "prestazioni/offerte/recap/[id]": {
      it: "/prestazioni/offerte/recap/[id]",
      en: "/services/offers/recap/[id]",
      fr: "/prestations/offres/recap/[id]",
      es: "/servicios/ofertas/recap/[id]",
      ro: "/servicii/oferte/recap/[id]"
    },
    "prestazioni/offerte/crea/index": {
      it: "/prestazioni/offerte/crea",
      en: "/services/offers/create",
      fr: "/prestations/offres/creer",
      es: "/servicios/ofertas/crear",
      ro: "/servicii/oferte/creare"
    },
    "prestazioni/offerte/importa/index": {
      it: "/prestazioni/offerte/importa",
      en: "/services/offers/import",
      fr: "/prestations/offres/importer",
      es: "/servicios/ofertas/importar",
      ro: "/servicii/oferte/import"
    },
    "prestazioni/ordini/index": {
      it: "/prestazioni/ordini",
      en: "/services/orders",
      fr: "/prestations/commandes",
      es: "/servicios/pedidos",
      ro: "/servicii/comenzi"
    },
    "prestazioni/ordini/[id]/index": {
      it: "/prestazioni/ordini/[id]",
      en: "/services/orders/[id]",
      fr: "/prestations/commandes/[id]",
      es: "/servicios/pedidos/[id]",
      ro: "/servicii/comenzi/[id]"
    },
    "prestazioni/ordini/crea/index": {
      it: "/prestazioni/ordini/crea",
      en: "/services/orders/create",
      fr: "/prestations/commandes/creer",
      es: "/servicios/pedidos/crear",
      ro: "/servicii/comenzi/creare"
    },
    "pulizia/calendario/index": {
      it: "/pulizia/calendario",
      en: "/cleaning/calendar",
      fr: "/nettoyage/calendrier",
      es: "/limpieza/calendario",
      ro: "/curatenie/calendar"
    },
    "pulizia/anagrafica-pulitori/index": {
      it: "/pulizia/anagrafica-operatori",
      en: "/cleaning/route-operators-registry",
      fr: "/nettoyage/registre-operateurs",
      es: "/limpieza/registro-operadores",
      ro: "/curatenie/registru-operatori"
    },
    "pulizia/gestione/index": {
      it: "/pulizia/gestione",
      en: "/cleaning/management",
      fr: "/nettoyage/gestion",
      es: "/limpieza/gestion",
      ro: "/curatenie/gestionare"
    },
    "amministrazione/index": {
      it: "/amministrazione",
      en: "/administration",
      fr: "/administration",
      es: "/administracion",
      ro: "/administrare"
    },
    "amministrazione/fatture/index": {
      it: "/amministrazione/fatture",
      en: "/administration/invoices",
      fr: "/administration/factures",
      es: "/administracion/facturas",
      ro: "/administrare/facturi"
    },
    "amministrazione/fatture-veicoli/index": {
      it: "/amministrazione/fatture-veicoli",
      en: "/administration/vehicle-invoices",
      fr: "/administration/factures-vehicules",
      es: "/administracion/facturas-vehiculos",
      ro: "/administrare/facturi-vehicule"
    },
    "amministrazione/insurance/index": {
      it: "/amministrazione/insurance",
      en: "/administration/insurance",
      fr: "/administration/assurance",
      es: "/administracion/seguros",
      ro: "/administrare/asigurari"
    },
    "amministrazione/pro-forma/index": {
      it: "/amministrazione/pro-forma",
      en: "/administration/pro-forma",
      fr: "/administration/pro-forma",
      es: "/administracion/pro-forma",
      ro: "/administrare/pro-forma"
    },
    "magazzino/gestione/index": {
      it: "/magazzino/gestione",
      en: "/warehouse/management",
      fr: "/entrepot/gestion",
      es: "/almacen/gestion",
      ro: "/depozit/gestionare"
    },
    "magazzino/automezzi/index": {
      it: "/magazzino/automezzi",
      en: "/warehouse/vehicles",
      fr: "/entrepot/vehicules",
      es: "/almacen/vehiculos",
      ro: "/depozit/autovehicule"
    },
    "magazzino/articoli/index": {
      it: "/magazzino/articoli",
      en: "/warehouse/items",
      fr: "/registre/articles",
      es: "/almacen/articulos",
      ro: "/depozit/articole"
    },
    "magazzino/esolver/index": {
      it: "/magazzino/esolver",
      en: "/warehouse/esolver",
      fr: "/entrepot/esolver",
      es: "/almacen/esolver",
      ro: "/depozit/esolver"
    },
    "crm/prospect/index": {
      it: "/marketing/prospect",
      en: "/marketing/prospects",
      fr: "/marketing/prospects",
      es: "/marketing/prospectos",
      ro: "/marketing/prospecti"
    },
    "crm/prospect/[id]": {
      it: "/marketing/prospect/[id]",
      en: "/marketing/prospects/[id]",
      fr: "/marketing/prospects/[id]",
      es: "/marketing/prospectos/[id]",
      ro: "/marketing/prospecti/[id]"
    },
    "crm/calendario/index": {
      it: "/marketing/calendario",
      en: "/marketing/calendar",
      fr: "/marketing/calendrier",
      es: "/marketing/calendario",
      ro: "/marketing/calendar"
    },
    "mappa/index": {
      it: "/mappa",
      en: "/map",
      fr: "/carte",
      es: "/mapa",
      ro: "/harta"
    },
    "pulizia/index": {
      it: "/pulizia",
      en: "/cleaning",
      fr: "/nettoyage",
      es: "/limpieza",
      ro: "/curatenie"
    },
    "vettori/index": {
      it: "/vettori",
      en: "/carriers",
      fr: "/transporteurs",
      es: "/transportistas",
      ro: "/transportatori"
    },
    "notifiche/index": {
      it: "/notifiche",
      en: "/notifications",
      fr: "/notifications",
      es: "/notificaciones",
      ro: "/notificari"
    },
    "settings/index": {
      it: "/impostazioni",
      en: "/settings",
      fr: "/parametres",
      es: "/configuracion",
      ro: "/setari"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "it",
    language: "it-IT",
    name: "Italiano",
    files: [
      {
        path: "/src/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    files: [
      {
        path: "/src/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    files: [
      {
        path: "/src/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-ES",
    name: "Español",
    files: [
      {
        path: "/src/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro",
    language: "ro-RO",
    name: "Română",
    files: [
      {
        path: "/src/i18n/locales/ro.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/